// extracted by mini-css-extract-plugin
export default {"cardsWrapper":"Angebote_cardsWrapper__G2srI","card-menu":"Angebote_card-menu__HkVbd","cardsContainer":"Angebote_cardsContainer__qRhIB","contactLink":"Angebote_contactLink__lYyGZ"};